import debounce from 'lodash.debounce';

import {addItem} from 'ducks/basket';


export default (selector, store) => {
    const elements = document.querySelectorAll(selector);

    [].forEach.call(elements, (elem) => {
        const id = elem.getAttribute('data-product-id');
        const title = elem.getAttribute('data-product-title');
        let counter = 0;

        if (!id) {
            return;
        }

        function onSubmit() {
            store.dispatch(addItem(id, title, counter || 1));
            counter = 0;
        }

        const callBack = debounce(onSubmit, 300);

        const increment = (evt) => {
            evt.preventDefault();
            const quantitySelector = elem.querySelector('#id_quantity');
            counter += parseInt(quantitySelector.value, 10);

            callBack(evt);
        };

        elem.addEventListener('submit', increment);
    });
};



// WEBPACK FOOTER //
// ./src/widgets/AddToCart.js